
		<div class="modal-header">
			<h4 class="modal-title">{{title}}</h4>
			<button
				type="button"
				class="close"
				aria-label="Close"
				(click)="close()"
				[sextant]="'cancelBaseModal'"
			>
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<ng-content></ng-content>
			
			<loading [isLoad]="isLoading"></loading>
			
			<div class="alert alert-danger" *ngIf="form?.sendFormError">
				{{ form?.sendFormError.message }}
			</div>
		</div>
		<div class="modal-footer">
			<button
				type="button"
				class="btn btn-default"
				(click)="close()"
				*ngIf="btnCloseDisplay"
				[sextant]="'cancelBaseModal'"
			>Отмена</button>
			
			<button
				type="button"
				class="btn"
				[ngClass]="btnOkClass"
				[disabled]="!isBtnOkActive"
				(click)="ok()"
				#btnOk
				[sextant]="'okBaseModal'"
			>{{btnOkLabel}}</button>
		</div>